import * as CryptoJS from 'crypto-js'

const CRYPTO = {
    // 加密
    getAesString: function(val,keys){ 
        let options = {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
        let key1 = CryptoJS.enc.Base64.parse(keys) //base64转码
        let key2 = key1.toString(CryptoJS.enc.Utf8); //转码后的内容字符串划
        let key= CryptoJS.enc.Utf8.parse(key2) //key值转换成utf8可读取模式
        let encryptedData = CryptoJS.AES.encrypt(val, key, options);
        let encryptedBase64Str = encryptedData.toString();
        return encryptedBase64Str;
    },
    // 解密
    getDAesString: function(val,keys){
        let options = {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
        let key1 = CryptoJS.enc.Base64.parse(keys) //base64转码
        let key2 = key1.toString(CryptoJS.enc.Utf8); //转码后的内容字符串划
        let key= CryptoJS.enc.Utf8.parse(key2) //key值转换成utf8可读取模式
        var decryptedData = CryptoJS.AES.decrypt(val, key, options);  
        // 解密后，需要按照Utf8的方式将明文转位字符串
        let decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
        return decryptedStr
    }
}
export default CRYPTO